import Link from "@mui/material/Link";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import { DateTime } from "luxon";

import { globalText } from "../../../assets/texts";
import { useAuthContext } from "../../../Context/AuthContext";
import { dateFormatDayMonthYear } from "../../../utils/dateTimeFormats";
import { ThreeDotsMenu } from "../../ThreeDotsMenu";
import { type GCPPricebook } from "../Types";

export type Props = {
  row: GCPPricebook;
  handleOpenDialog: (row: GCPPricebook | null) => () => void;
};

export const GCPPricebookRow = ({ row, handleOpenDialog }: Props) => {
  const { isDoitDeveloper } = useAuthContext();

  const threeDotsMenuOptions = [
    {
      label: <Typography>{globalText.EDIT}</Typography>,
      action: handleOpenDialog(row),
      key: globalText.EDIT,
    },
  ];

  return (
    <>
      <TableCell data-cy="customerName">
        <Link href={`/customers/${row.customer.id}`} color="inherit" target="_blank">
          {row?.metadata?.customer.name}
        </Link>
      </TableCell>
      <TableCell
        data-cy="startDate"
        sx={{
          display: {
            xs: "none",
            md: "table-cell",
          },
        }}
      >
        {DateTime.fromSeconds(row.startDate.seconds).toFormat(dateFormatDayMonthYear)}
      </TableCell>
      <TableCell
        data-cy="endDate"
        sx={{
          display: {
            xs: "none",
            md: "table-cell",
          },
        }}
      >
        {DateTime.fromSeconds(row.endDate.seconds).toFormat(dateFormatDayMonthYear)}
      </TableCell>
      <TableCell align="left" data-cy="tableName">
        {row.tableRef}
      </TableCell>
      {isDoitDeveloper && (
        <TableCell padding="none" data-cy="threeDots">
          <ThreeDotsMenu size="small" options={threeDotsMenuOptions} closeAfterSelect />
        </TableCell>
      )}
    </>
  );
};
